export default[
  {
    path: '/api/interface/item',
    name: 'InterfaceItemInfo',
    meta: {
      pageTitle: '인터페이스',
      title: '인터페이스 항목관리',
      authRequired: true,
    },
    component: () => import('@/views/interface/interfaceItemInfo')
  },
  {
    path: '/api/interface/hist',
    name: 'InterfaceHistory',
    meta: {
      pageTitle: '인터페이스',
      title: '인터페이스 이력',
      authRequired: true,
    },
    component: () => import('@/views/interface/interfaceHistory')
  },
  {
    path: '/api/interface/dataHist',
    name: 'InterfaceDataHistory',
    meta: {
      pageTitle: '인터페이스',
      title: '인터페이스 데이터 이력',
      authRequired: true,
    },
    component: () => import('@/views/interface/interfaceDataHist')
  },

]